import { createReducer, on } from '@ngrx/store';
import { DeviceStats } from '../../shared/models/DeviceChartInfo';
import * as StoveStatsActions from './stove-stats.actions';

export interface StoveStatsState {
  deviceStats: DeviceStats | null;
  loading: boolean;
  error: string | null;
}

export const initialState: StoveStatsState = {
  deviceStats: null,
  loading: false,
  error: null,
};

export const stoveStatsReducer = createReducer(
  initialState,

  on(StoveStatsActions.loadDeviceStats, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(StoveStatsActions.loadDeviceStatsSuccess, (state, { deviceStats }) => ({
    ...state,
    deviceStats,
    loading: false,
    error: null,
  })),

  on(StoveStatsActions.loadDeviceStatsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(StoveStatsActions.setDeviceStats, (state, { deviceStats }) => ({
    ...state,
    deviceStats,
    loading: false,
    error: null,
  })),

  on(StoveStatsActions.clearDeviceStats, () => initialState),
);
